require('dotenv-flow').config();
import { setConfig } from 'dot-utils';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

setConfig({
	APP_URL: process.env.APP_URL,
});

Sentry.init({
	dsn: process.env.LOGGING_KEY,
	integrations: [new Integrations.BrowserTracing()],

	// We recommend adjusting this value in production, or using tracesSampler
	// for finer control
	tracesSampleRate: 1.0,
});
